import { toast } from "react-toastify";

toast.configure();

const success = (message, align = "bottom-center", time = 5000) => {
  toast.success(message, {
    position: align,
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

const error = (message, align = "bottom-center", time = 5000) => {
  toast.error(message, {
    position: align,
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

const info = (message, align = "bottom-center", time = 7000) => {
  toast.info(message, {
    position: align,
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

const warning = (message, align = "bottom-center", time = 7000) => {
  toast.warn(message, {
    position: align,
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const Note = {
  success,
  error,
  info,
  warning,
};
